import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { availabilityOptionNames } from 'components/settings/components/sections/dixaMessenger/views/flow/components/nodeTypeAvailability/availabilityModal/availabilityOptions';
import { flowNodeColor } from 'fable/flowEditor';
import { TextBreak } from 'fable/flowEditor/components/flowManager/canvas/node/textBreak';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { AvailabilityModal } from '../availabilityModal';
const connectionLabels = {
    notAvailableBranch: 'Not available',
    availableBranch: 'Available',
};
const translatePayload = ({ payload, }) => {
    return [
        {
            id: uuid(),
            label: connectionLabels.availableBranch,
            connection: payload.availableNextNodeId,
        },
        {
            id: uuid(),
            label: connectionLabels.notAvailableBranch,
            connection: payload.notAvailableNextNodeId,
        },
    ];
};
const updateConnection = (node, connection, connectionId) => {
    const { payload } = node;
    const fieldToUpdate = connection.connectionLabel === connectionLabels.availableBranch
        ? 'availableNextNodeId'
        : 'notAvailableNextNodeId';
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { [fieldToUpdate]: connectionId }) });
};
export const AvailabilityNodeAttributes = {
    iconName: 'hide-strategy',
    label: 'Agent availability',
    color: hexStringToNumber(flowNodeColor.purple),
    translatePayload,
    updateConnection,
    NodeContent: AvailabilityNode,
    ActionModal: AvailabilityModal,
};
export function AvailabilityNode({ node }) {
    const { payload: { query }, } = node;
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(TextBreak, { children: [_jsx(Text, { weight: "normal", text: "Strategy:" }), _jsx(Text, { weight: "semibold", text: availabilityOptionNames[query.type] })] })), [query]) }));
}
